import React from 'react';
import { Input } from '@components/basics/forms/inputs/Input';
import { Button } from '@components/main-components/button/Button';

export const UrlCopy = ({
  url,
  isCopied,
  onCopyClick,
}: {
  url: string;
  isCopied: boolean;
  onCopyClick: () => void;
}) => {
  return (
    <div className="mb-0.5 flex h-10 w-full gap-2">
      <Input
        disabled
        value={url.replace('https://', '').replace('www.', '')}
        className="truncate !text-black"
      />
      <div className="w-[78px]">
        <Button
          variant="primary"
          label={isCopied ? 'Copied' : 'Copy'}
          disabled={isCopied}
          className="h-full w-full min-w-0"
          onClick={onCopyClick}
        />
      </div>
    </div>
  );
};
